// Canonical, ordered list of the releases shown on /updates. The order MUST mirror
// the card order in PageUpdates.vue, because showReadLineAfter() decides where to
// draw the "read up to here" line by comparing each entry with the NEXT one here.
// That is newest first, EXCEPT for an upcoming ("Coming soon") release, which stays
// pinned at the top of the page even once a newer release ships below it.
// This is the single source of truth for the unread logic:
//   - TheNavbar uses it to compute the red unread badge count.
//   - PageUpdates uses it to place the "read up to here" line.
// `publishedAt` is the FULL UTC timestamp when the update went live (NOT just the
// day) so that a same-day publish is compared correctly and the badge clears as
// soon as the user visits after that moment — not only once the calendar day
// rolls over. Its DAY must match the date shown on the matching card in
// PageUpdates.vue. When you add a release: add its { id, publishedAt } here (at
// the top, with the real UTC publish time) AND its card. `id` = the card's DOM
// id (also its deep-link anchor). No DB — see store `updatesLastReadAt`
// (persisted to localStorage) for the last-visit timestamp.
export const UPDATES = [
  { id: 'ibkr-integration', publishedAt: '2026-08-02T13:10:00Z' }, // pinned on top, see above
  { id: 'stablecoin-yield', publishedAt: '2026-08-02T13:10:00Z' },
  { id: 'hyperliquid-key-validation', publishedAt: '2026-07-19T09:15:00Z' },
  { id: 'okx-eu-futures', publishedAt: '2026-07-15T11:30:00Z' },
  { id: 'api-keys', publishedAt: '2026-06-26T09:00:00Z' },
  { id: 'mcp-ai-strategies', publishedAt: '2026-06-14T11:30:00Z' },
  { id: 'trend-radar', publishedAt: '2026-04-07T15:40:00Z' },
  { id: 'bybit-eu', publishedAt: '2026-03-07T11:30:00Z' }
]

// How many releases are newer than the user's last visit.
// lastReadAt is an ISO timestamp string (or null/'' if they never visited, in
// which case everything counts as unread).
export function updatesUnreadCount (lastReadAt) {
  const parsed = lastReadAt ? new Date(lastReadAt).getTime() : 0
  // Fail safe: a corrupted (unparseable) value parses to NaN, and `x > NaN` is
  // always false, which would silently hide every update. Treat NaN as "never
  // visited" (0) so genuinely-new updates still surface.
  const last = Number.isNaN(parsed) ? 0 : parsed
  return UPDATES.filter(u => new Date(u.publishedAt).getTime() > last).length
}
